import Dashboard from './Dashboard';
import { connect } from 'react-redux';



const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

const DashboardConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);


export default DashboardConnect;


/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/DashboardConnect.js
 **/